import React from 'react';

// Styles & Assets
import styles from './TakenOptions.module.css';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import CheckboxButton from '../../UI/CheckboxButton/CheckboxButton';

// Interfaces
interface Props {
    professionalAdmin: boolean
    counter: number
    handleChangeCounter: (num: number) => void
    handleChangeAdmin: () => void
}

const TakenOptions: React.FC<Props> = ({ professionalAdmin, counter, handleChangeCounter, handleChangeAdmin }) => {

    const { t } = useTranslation();

    return (
        <div className={styles.takenOptions}>
            <div className={styles.checkboxContainer}>
                <CheckboxButton
                    onClick={handleChangeAdmin}
                    checked={professionalAdmin}
                    label={t('dispensed_professional')}
                />
            </div>
            <div className={styles.counterWrapper}>
                <p>{t('rescue_dose')}:</p>
                <div className={styles.counterContainer}>
                    <button
                        onClick={() => handleChangeCounter(-1)}
                        className={`button ${styles.buttonCounter}`}
                    >-</button>
                    <div className={styles.numContainer}>
                        <p>{counter}</p>
                    </div>
                    <button
                        onClick={() => handleChangeCounter(+1)}
                        className={`button ${styles.buttonCounter}`}
                    >+</button>
                </div>
            </div>
        </div>
    );
};

export default TakenOptions;